// product-swipe.js — enable finger swipe on ritual slideshow (mobile)
document.addEventListener('DOMContentLoaded', () => {
  // เลือกเฉพาะ UL/คอนเทนเนอร์ที่เลื่อนจริง ๆ
  const lists = document.querySelectorAll(
    'slideshow-component .slideshow__slides, .slider--mobile, .product__media-list'
  );

  lists.forEach((el) => {
    el.style.overflowX = 'auto';
    el.style.webkitOverflowScrolling = 'touch';
    el.style.scrollSnapType = 'x mandatory';
    el.style.touchAction = 'pan-x';

    let startX = 0;
    let startLeft = 0;
    let dragging = false;

    el.addEventListener('touchstart', (e) => {
      if (!e.touches?.length) return;
      dragging = true;
      startX = e.touches[0].clientX;
      startLeft = el.scrollLeft;
    }, { passive: true });

    el.addEventListener('touchmove', (e) => {
      if (!dragging || !e.touches?.length) return;
      const dx = e.touches[0].clientX - startX;
      el.scrollLeft = startLeft - dx; // เลื่อนตามนิ้ว
    }, { passive: true });

    el.addEventListener('touchend', () => { dragging = false; });
  });
});
